import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import OfficeFluentProvider from '@office-start/office-fluent-provider';
import VisualBackgroundComponent from '@office-start/visual-background-component';
import React from 'react';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ObservableScope } from '../shared/models/observable-scope.enum';
import { bootstrapOfficeStartComponent } from '../shared/office-start/bootstrap-office-start-component';
import { OfficeStartBootstrapperService } from '../shared/office-start/office-start-bootstrapper.service';
import ReactRenderer from '../shared/react/react-renderer';
import { EventService } from '../shared/services/event.service';
import { ThemingService } from '../shared/services/theming.service';
import { AngularEvents } from '../shared/shared-context/angular-events';

@Directive({ selector: 'ohp-visual-background-react-content' })
export class VisualBackgroundReactContentDirective extends ReactRenderer implements OnInit, OnDestroy {

    private widthRestrictorSubscription: Subscription;
    private widthRestrictorOffset: string | undefined;

    constructor(elementRef: ElementRef, private readonly eventService: EventService, officeStartBootstrapperService: OfficeStartBootstrapperService, themingService: ThemingService) {
        super(elementRef);
        bootstrapOfficeStartComponent(officeStartBootstrapperService, themingService);
    }

    public ngOnInit() {
        super.ngOnInit();
        this.widthRestrictorSubscription = this.eventService.events.withScope(ObservableScope.PastAndFuture)
            .pipe(
                filter(event => event.name === AngularEvents.widthRestrictorComputedStyle)
            )
            .subscribe(event => {
                if (event.args.length) {
                    this.widthRestrictorOffset = event.args[0]['margin-left'];
                    this.render();
                }
            });
    }

    public ngOnDestroy() {
        super.ngOnDestroy();
        this.widthRestrictorSubscription?.unsubscribe();
    }

    public async getReactElement() {
        return (
            <OfficeFluentProvider>
                <VisualBackgroundComponent widthRestrictorOffset={this.widthRestrictorOffset ?? undefined}/>
            </OfficeFluentProvider>
        );
    }
}
